export default __webpack_public_path__ + "static/header-3a2d9598f77cba123482a01367ec00d6.png";